module.exports = __webpack_public_path__ + "media/images/no-results-d99c697def90573ce39b7025dc0866af.svg";